import { IconMessageDots } from '@tabler/icons-react';
import { ICreateThemeData } from 'src/types';
import { getToggleButtonStyle } from './videoUtils';
import VideoMessageBox from './VideoMessageBox';
import { translations } from '../../../translations/chatInputTranslations';

interface VideoQuestionToggleProps {
  isWebcamReady: boolean;
  isMessageOpen: boolean;
  onToggle: () => void;
  text: string;
  hasMedia: boolean;
  themeData: ICreateThemeData;
  languageCode: string;
}

function VideoQuestionToggle({
  isWebcamReady,
  isMessageOpen,
  onToggle,
  text,
  hasMedia,
  themeData,
  languageCode,
}: VideoQuestionToggleProps) {
  const t = translations[languageCode] || translations.en;

  if (!isWebcamReady) {
    return null;
  }

  return (
    <div className="absolute bottom-6 min500:left-1/2 min500:-translate-x-1/2 left-3 min500:right-4 rounded-lg shadow-lg z-50 min500:w-[calc(100%-2rem)] w-[calc(100%-1.6rem)] gap-1 max-w-md min500:min-h-[50%] h-auto transparent flex flex-col items-start justify-between">
      <IconMessageDots
        size={32}
        className="text-white rounded-full p-1.5 hidden min500:block"
        style={getToggleButtonStyle(!isMessageOpen, themeData)}
        onClick={onToggle}
      />
      {!isMessageOpen && (
        <button
          onClick={onToggle}
          className="text-white text-xs px-3 py-1.5 rounded-full font-medium block min500:hidden"
          style={getToggleButtonStyle(!isMessageOpen, themeData)}
          type="button"
        >
          {t.showQuestion}
        </button>
      )}
      <VideoMessageBox
        isOpen={isMessageOpen}
        text={text}
        hasMedia={hasMedia}
        themeData={themeData}
        onClose={onToggle}
        t={t}
      />
    </div>
  );
}

export default VideoQuestionToggle;
